import React from 'react';
import { ErrorMessage as Message, connect } from 'formik';
import ErrorMessageTemplate from './ErrorMessageTemplate';
import ValidationStatus from './ValidationStatus';

const ErrorMessage = (props) => {
    return (
        <>
            <Message {...props} render={(msg) => <ErrorMessageTemplate message={msg} />} />
            {props.formik.status ? <ValidationStatus status={props.formik.status} name={props.name} /> : null}
        </>
    );
};

export default connect(ErrorMessage);
